/** 大陆身份证校验位权重 */
const CN_WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
const CN_CHECK_CODES = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

/** 输入过程过滤：大陆身份证（前 17 位数字，末位数字或 X） */
export function sanitizeIdCn(value: string): string {
  let out = '';
  for (const ch of value) {
    if (out.length >= 18) break;
    if (out.length < 17) {
      if (/\d/.test(ch)) out += ch;
    } else if (/[\dXx]/.test(ch)) {
      out += ch.toUpperCase();
    }
  }
  return out;
}

/** 完整校验：大陆 18 位身份证（含校验位） */
export function validateIdCn(value: string): boolean {
  const v = value.trim().toUpperCase();
  if (!/^\d{17}[\dX]$/.test(v)) return false;
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += Number(v[i]) * CN_WEIGHTS[i];
  }
  return CN_CHECK_CODES[sum % 11] === v[17];
}

/**
 * 香港身份证输入过滤。
 * 常见形态：A123456(7) / AB123456(7)
 */
export function sanitizeIdHk(value: string): string {
  const cleaned = value.toUpperCase().replace(/[^A-Z0-9()]/g, '');
  let out = '';
  for (const ch of cleaned) {
    if (out.length >= 11) break;
    const next = out + ch;
    if (/^[A-Z]{0,2}\d{0,6}\(?[0-9A]?\)?$/.test(next)) {
      out = next;
    }
  }
  return out;
}

/** 香港身份证完整校验（含括号校验位可选） */
export function validateIdHk(value: string): boolean {
  const v = value.trim().toUpperCase().replace(/\s/g, '');
  // A123456(7) 或 A1234567
  const m = v.match(/^([A-Z]{1,2})(\d{6})\(?([0-9A])\)?$/);
  if (!m) return false;
  return validateHkCheckDigit(m[1], m[2], m[3]);
}

function validateHkCheckDigit(letters: string, digits: string, check: string): boolean {
  // 标准加权：空位补空格(ASCII 空间按 36? 常用算法：首位空为 36)
  const chars = (letters.length === 1 ? ` ${letters}` : letters) + digits;
  let sum = 0;
  for (let i = 0; i < chars.length; i++) {
    const c = chars[i];
    const code = c === ' ' ? 36 : c >= 'A' && c <= 'Z' ? c.charCodeAt(0) - 55 : Number(c);
    sum += code * (9 - i);
  }
  const rem = sum % 11;
  const expected = rem === 0 ? '0' : rem === 1 ? 'A' : String(11 - rem);
  return expected === check;
}

/**
 * 澳门身份证输入过滤。
 * 常见为 8 位数字，或带括号校验位形态。
 */
export function sanitizeIdMo(value: string): string {
  const cleaned = value.toUpperCase().replace(/[^0-9()]/g, '');
  let out = '';
  for (const ch of cleaned) {
    if (out.length >= 10) break;
    const next = out + ch;
    if (/^\d{0,8}\(?\d?\)?$/.test(next)) {
      out = next;
    }
  }
  return out;
}

/** 澳门身份证：8 位数字，或 7 位+括号校验位 */
export function validateIdMo(value: string): boolean {
  const v = value.trim().replace(/\s/g, '');
  if (/^\d{8}$/.test(v)) return true;
  return /^\d{7}\(\d\)$/.test(v);
}
